// extracted by mini-css-extract-plugin
export default {"icons":"ConfigMenu_icons__U1-US"};